<template>
  <div class="header-menu">
    <div class="menu-li menu-hover-open" @mouseenter="hoverIn(0)" @mouseleave="hoverOut(0)">
      <div class="title" @click="toGo(0)">产品系列</div>
      <div v-if="productMenuShow" class="menu-sub product">
        <div v-for="(item, index) in productList" :key="index" class="sub-item-block">
          <div v-for="(subItem, subIndex) in item" :key="subIndex" class="sub-item" @click="subToGo(subItem.url)">
            <span
              >{{ subItem.title }}
              <!-- <a v-show="subIndex == 3 && index == 1">{{ subItem.subTitle }}</a> -->
            </span>
            <span v-show="subItem.content">{{ subItem.content }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="menu-li menu-hover-open" @mouseenter="hoverIn(1)" @mouseleave="hoverOut(1)">
      <div class="title" @click="toGo(1)">教学体系</div>
      <div v-if="sourceMenuShow" class="menu-sub source">
        <div v-for="(item, index) in sourceList" :key="index" class="sub-item-block">
          <div v-for="(subItem, subIndex) in item" :key="subIndex" class="sub-item" @click="subToGo(subItem.url)">
            <span>{{ subItem.title }}</span>
            <span>{{ subItem.content }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="menu-li menu-hover">
      <div class="title" @click="toGo(2)">培训认证</div>
    </div>
    <div class="menu-li menu-hover">
      <div class="title" @click="toGo(3)">创意大赛</div>
    </div>
    <div class="menu-li menu-hover">
      <div class="title" @click="toGo(4)">飞翔H5</div>
    </div>
    <div class="menu-li menu-hover">
      <div class="title" @click="toGo(5)">云阅读</div>
    </div>
    <!-- <div class="menu-li menu-hover">
      <div class="title" @click="toGo(6)">论文排版审校</div>
    </div> -->
    <div class="menu-li menu-hover" v-if="typeSetSwitch">
      <div class="title" @click="toGo(7)">智能排版</div>
    </div>
    <div class="menu-li menu-hover">
      <div class="title" @click="toGo(8)">阅新闻</div>
    </div>
  </div>
</template>
<script>
import apis from '@api/typeSetLock.js'
export default {
  data() {
    return {
      baseUrl: window.PROJECT_CONFIG.BASE_URL,
      baseUrl2: window.PROJECT_CONFIG.BASE_URL2,
      productList: [
        [
          { title: '方正飞翔(印刷)', content: '图书期刊等出版物的排版、EPUB同步输出', url: '/product/1012.jhtml' },
          { title: '方正飞翔创意版', content: '集印刷版与数字版之大成者', url: '/product/105.jhtml' },
          { title: '方正书版', content: '图书、公文排版软件', url: '/product/102.jhtml' },
          { title: '方正字库', content: '图书、期刊等纸媒字库授权', url: '/product/104.jhtml' },
          { title: '查看全部', content: '', url: '/product/productCenter.jhtml' }
        ],
        [
          { title: '方正飞翔(数字)', content: 'H5交互融媒体制作工具', url: '/product/101.jhtml' },
          { title: '产品升级', content: '方正飞翔、方正书版升级', url: '/product/upgrade.jhtml' },
          { title: '输出软件', content: '文件输出校样工具', url: '/product/outputSoftware.jhtml' },
          { title: '云阅读', content: '上传PDF一键转换发布仿真在线电子书刊', url: '/elecPublish' },
          { title: '方正畅易', content: '智能文件差异比对工具', url: '/product/changyi.jhtml' }
        ]
      ],
      sourceList: [
        [
          { title: '精选视频教程', content: '按照排版专题、软件功能模块讲解软件操作', url: '/h5/courseList.jhtml' },
          { title: '直播课程回顾', content: '方正飞翔、方正字库往期直播课精彩回顾', url: '/fly/train/liveCourses.jhtml' },
          { title: '实用排版技巧', content: '方正飞翔实用技能、排版技巧分享', url: '/fly/train/courseList/144.jhtml' }
        ]
      ],
      productMenuShow: false,
      sourceMenuShow: false,
      urlList: [
        '/product/productCenter.jhtml',
        '/h5/courseList.jhtml',
        '/fly/train/abilityAuthen.jhtml',
        '/contest/index.jhtml',
        '/h5/toH5Index.jhtml',
        '',
        '/contest/typography.jhtml',
        '/autoTypeSet/template/list.jhtml',
        '/product/yueNews/index.jhtml'
      ],
      typeSetSwitch: null
    }
  },
  methods: {
    hoverIn(type) {
      switch (type) {
        case 0:
          this.productMenuShow = true
          break
        case 1:
          this.sourceMenuShow = true
      }
    },
    hoverOut(type) {
      switch (type) {
        case 0:
          this.productMenuShow = false
          break
        case 1:
          this.sourceMenuShow = false
      }
    },
    toGo(index) {
      if (!this.urlList[index]) {
        //电子书刊暂时没有地址 返回到上传页
        this.$router.push('/')
      } else {
        let a = document.createElement('a')
        a.href = this.baseUrl + this.urlList[index]
        a.click()
      }
    },
    subToGo(url) {
      let a = document.createElement('a')
      if (url == '/extetnalApi/course/list') {
        a.href = this.baseUrl2 + url
      } else {
        a.href = this.baseUrl + url
      }
      a.click()
    },
    getTypeSetLock() {
      apis.isLockTypeSet().then((res) => {
        if (res.data.status == 0) {
          this.typeSetSwitch = res.data.data.typeSetSwitch //0关闭、1开启
        }
      })
    }
  },
  mounted() {
    this.getTypeSetLock()
  }
}
</script>
<style lang="scss">
.header-menu {
  display: flex;
  // height: 100%;
  height: 80px;
  .menu-li {
    padding: 0 20px;
    height: 100%;
    white-space: nowrap;
    position: relative;
    z-index: 101;
    cursor: pointer;
    .title {
      height: 100%;
      line-height: 80px;
      display: flex;
      align-items: center;
      img {
        width: 31px;
        height: 14px;
        margin-bottom: 5px;
        margin-left: 5px;
      }
      &.new-logo:after {
        content: 'new';
        display: inline-block;
        background: #df5813;
        color: #fff;
        padding: 0 5px;
        margin-left: 5px;
        margin-bottom: 15px;
        border-radius: 10px;
        border-bottom-left-radius: 0;
        font-size: 12px;
        height: 17px;
        line-height: 17px;
      }
    }
    .menu-sub {
      position: absolute;
      left: 0;
      background-color: #fff;
      border: 1px solid #f3f3f3;
      display: flex;
      z-index: 9999;

      .sub-item-block {
        width: 320px;

        &:first-of-type {
          border-right: 1px solid #f3f3f3;
        }
        .sub-item {
          margin: 20px 0;
          color: #656565;
          font-size: 14px;
          padding: 10px 30px;
          span:first-of-type {
            color: #333;
          }
          &:hover {
            background-color: #f4f4f4;
            span:first-of-type {
              color: #df5813;
            }
          }
          span {
            display: block;
            height: 20px;
            &:first-of-type {
              font-size: 14px;
              font-weight: bold;
            }
            a {
              margin: 0;
              border: 2px solid #df5813;
              border-radius: 4px;
              font-size: 9px;
              display: inline-block;
              margin-left: 7px;
              color: #df5813;
              width: 23px;
              vertical-align: top;
              text-align: center;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
  .menu-hover:hover {
    color: #df5813;
  }
  .menu-hover-open:hover {
    border-top: solid 2px #df5813;
    color: #df5813;
    background-color: #f4f4f4;
  }
}
</style>
